import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import AdminNavigationProtectionLayout from 'shared/Layouts/TopNavigationLayout/AdminNavigationProtectionLayout'
import ScheduleProtection from './components/schedule/ScheduleProtection'

const ProtectionScheduleAdminPage = () => {
  return (
    <AdminNavigationProtectionLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '32px' }}>
            <h2 className='text--heading-h4 page--header' style={{ flexShrink: 0 }}>
              Расписание защит
            </h2>
          </div>
        </div>
        <ScheduleProtection />
      </TopNavigationLayoutPageContent>
    </AdminNavigationProtectionLayout>
  )
}

export default ProtectionScheduleAdminPage
